<template>
  <section id="about" class="about section">
    <div class="container about__inner">
      <div class="about__content">
        <span class="about__label">关于我们</span>
        <h2 class="about__title">关于我们</h2>
        <p class="about__text">
          {{ company.fullName }}成立于十堰，是一家专注于政务人工智能与智慧城市建设的高新技术企业。
          公司汇聚了一批来自人工智能、大数据、云计算等领域的高端技术人才，致力于将前沿技术与政务管理深度融合。
        </p>
        <p class="about__text">
          我们秉承"技术驱动治理、数据赋能决策"的理念，已为湖北省及周边多个地市的20+政府部门提供了成熟的AI解决方案，
          覆盖组织管理、智慧巡检、纪检监察、社会治理等多个核心场景。
        </p>
        <p class="about__text">
          公司始终坚持以客户为中心，以技术创新为引擎，持续助力政务数字化转型与治理能力现代化建设。
        </p>
        <div class="about__actions">
          <a href="#products" class="btn btn-blue about__btn-primary">了解更多</a>
          <a href="#contact" class="btn about__btn-outline">联系我们</a>
        </div>
      </div>
      <div class="about__visual">
        <div class="about__card">
          <div class="about__card-glow" aria-hidden="true"></div>
          <div class="about__card-icon">🏢</div>
          <h3>{{ company.fullName }}</h3>
          <p class="about__card-desc">专注智慧政务解决方案<br>助力治理能力现代化</p>
          <div class="about__card-stats">
            <div class="about__card-stat">
              <strong>5+</strong>
              <span>年行业经验</span>
            </div>
            <div class="about__card-stat">
              <strong>20+</strong>
              <span>政企客户</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { company } from '../data/site'

export default {
  name: 'AboutSection',
  data() {
    return { company }
  }
}
</script>

<style scoped>
.about {
  background: linear-gradient(180deg, #fff 0%, #f7f9fc 100%);
}

.about__inner {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 72px;
  align-items: center;
}

.about__label {
  display: inline-block;
  font-size: 13px;
  font-weight: 600;
  color: #0052d9;
  padding: 6px 14px;
  background: #eef4ff;
  border-radius: 6px;
  margin-bottom: 16px;
}

.about__title {
  font-size: 36px;
  font-weight: 800;
  color: #1a1a2e;
  line-height: 1.25;
  margin-bottom: 24px;
  letter-spacing: -0.5px;
}

.about__text {
  font-size: 15px;
  color: #555;
  line-height: 1.85;
  margin-bottom: 16px;
}

.about__text:last-of-type {
  margin-bottom: 0;
}

.about__actions {
  display: flex;
  gap: 16px;
  margin-top: 32px;
  flex-wrap: wrap;
}

.about__btn-primary {
  padding: 13px 32px;
  border-radius: 10px;
  font-size: 15px;
  box-shadow: 0 6px 20px rgba(0, 82, 217, 0.3);
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.about__btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 28px rgba(0, 82, 217, 0.38);
}

.about__btn-outline {
  background: #fff;
  color: #0052d9;
  border: 1px solid #0052d9;
  padding: 13px 32px;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  transition: all 0.25s ease;
}

.about__btn-outline:hover {
  background: #f0f5ff;
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 82, 217, 0.12);
}

.about__visual {
  position: relative;
}

.about__card {
  position: relative;
  background: linear-gradient(145deg, #0052d9 0%, #0078ff 55%, #00a3ff 100%);
  border-radius: 20px;
  padding: 48px 40px 40px;
  color: #fff;
  text-align: center;
  overflow: hidden;
  box-shadow:
    0 20px 60px rgba(0, 82, 217, 0.35),
    inset 0 1px 0 rgba(255, 255, 255, 0.2);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.about__card:hover {
  transform: translateY(-6px);
  box-shadow:
    0 28px 72px rgba(0, 82, 217, 0.42),
    inset 0 1px 0 rgba(255, 255, 255, 0.2);
}

.about__card-glow {
  position: absolute;
  top: -40%;
  right: -20%;
  width: 280px;
  height: 280px;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.18) 0%, transparent 70%);
  pointer-events: none;
}

.about__card-icon {
  width: 72px;
  height: 72px;
  margin: 0 auto 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 36px;
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 18px;
  backdrop-filter: blur(8px);
}

.about__card h3 {
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 12px;
  line-height: 1.4;
}

.about__card-desc {
  font-size: 14px;
  opacity: 0.9;
  line-height: 1.7;
  margin-bottom: 32px;
}

.about__card-stats {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0;
  border-top: 1px solid rgba(255, 255, 255, 0.22);
  padding-top: 28px;
}

.about__card-stat {
  position: relative;
  padding: 0 16px;
}

.about__card-stat:first-child::after {
  content: '';
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 1px;
  height: 40px;
  background: rgba(255, 255, 255, 0.2);
}

.about__card-stat strong {
  display: block;
  font-size: 36px;
  font-weight: 800;
  margin-bottom: 6px;
  line-height: 1;
}

.about__card-stat span {
  font-size: 13px;
  opacity: 0.85;
}

@media (max-width: 768px) {
  .about__inner {
    grid-template-columns: 1fr;
    gap: 48px;
  }

  .about__title {
    font-size: 28px;
  }

  .about__card {
    padding: 36px 28px 32px;
  }
}
</style>
